import "../styles/main.scss";

import Vue from 'vue/dist/vue.esm.js';
//import Vue from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueLazyload from 'vue-lazyload';

//import App from './Components/App.vue';
import Lightbox from './Components/Lightbox.vue';
import Accordion from './Components/Accordion.vue';
import icons from './icons.js';

icons();

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueLazyload);

var app = new Vue({
  el: '#main-content',
  components: {
    Lightbox: Lightbox,
    Accordion: Accordion,
  }
});